import { createFileRoute } from '@tanstack/react-router';
import { Card, Stack, Text } from '@mantine/core';
import { IconTool } from '@tabler/icons-react';

export const Route = createFileRoute('/_public/maintenance')({ component: MaintenancePage });

function MaintenancePage() {
  return (
    <Card withBorder padding="xl" radius="md">
      <Stack align="center" gap="lg">
        <IconTool size={64} opacity={0.4} />
        <Text component="h1" fw={700} fz="var(--fs-h1)" lh={1.1} ta="center">Manutenzione in corso</Text>
        <Text c="dimmed" ta="center" maw={480}>
          Stiamo aggiornando la piattaforma. Torneremo online a breve.
          Se l'attesa si prolunga, contatta il tuo amministratore.
        </Text>
      </Stack>
    </Card>
  );
}
